import zViewIcon from './icon.vue'

zViewIcon.install = Vue => Vue.component(zViewIcon.name, zViewIcon)

export default zViewIcon